import base from './base';

const primaryColor = '#0090d2';
const primary = '#0090d2';
const hover = '#6aacc0';
const errorColor = '#d71f28';

const hum = base({primaryColor, primary, hover, errorColor, base});
hum.formLayout = {
  gap: '10px'
};

export default hum;
